import { render, staticRenderFns } from "./CreateList.vue?vue&type=template&id=5f20bcb8&scoped=true"
import script from "./CreateList.vue?vue&type=script&lang=js"
export * from "./CreateList.vue?vue&type=script&lang=js"
import style0 from "./CreateList.vue?vue&type=style&index=0&id=5f20bcb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f20bcb8",
  null
  
)

export default component.exports